import classNames from 'classnames';
import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { connect } from 'react-redux';
import {
  branch,
  renderComponent,
  withHandlers,
  withStateHandlers
} from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import Loading from '../../../pages/loading';
import ToggleBox from '../../toggle-box';
import { filterNonLegacy } from '../../../../common/cpd-category-filter';

const IndustryCpdCategoryFilter = ({
  onCpdCategoryFilterChange,
  toggleFilter,
  showFilter,
  cpdCategorys: cpdCategoryList,
  industriesWithCpdCategorys
}) => {
  return (
    <div className='filter cpd-category-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'
          >
            {showFilter ? (
              <Icon icon='minus-large'></Icon>
            ) : (
              <Icon icon='plus-large'></Icon>
            )}
            <span id='label'>CPD Category</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='industry-cpd-category-filter' in={showFilter}>
          <div>
            {fp.map(({ industry, cpdCategorys }) => {
              return (
                <form key={industry.id} id='selection-list'>
                  <h3>{he.decode(industry.name)}</h3>
                  <div>
                    {fp.flow(
                      fp.sortBy((cpdCategory) => cpdCategory.name),
                      fp.map(({ id, name }) => {
                        const entry = fp.find((entry) => entry.id === id)(
                          cpdCategoryList
                        );
                        const selected = fp.get('selected')(entry);
                        const boxLabel = selected ? <FiCheck /> : null;
                        return (
                          <Row
                            className={classNames('no-gutter', { selected })}
                            id='selection'
                            key={id}
                            onClick={() => {
                              onCpdCategoryFilterChange(id);
                            }}
                          >
                            <span id='checkbox'>
                              <ToggleBox
                                small
                                value={id}
                                label={boxLabel}
                                checked={selected}
                              />
                            </span>
                            <span>{he.decode(name)}</span>
                          </Row>
                        );
                      })
                    )(cpdCategorys)}
                  </div>
                </form>
              );
            })(industriesWithCpdCategorys)}
          </div>
        </Collapse>
      </Row>
    </div>
  );
};

const getUpdatedCpdCategorys = (cpdCategorys, cpdCategoryIdToToggle) =>
  fp.flow(
    fp.map((cpdCategory) => ({
      ...cpdCategory,
      selected:
        cpdCategory.id === cpdCategoryIdToToggle
          ? !cpdCategory.selected
          : cpdCategory.selected
    }))
  )(cpdCategorys);

const mapStateToProps = ({ industry, cpdCategorys }) => ({
  industriesWithCpdCategorys: industry.industriesWithCpdCategorys,
  allCpdCategories: cpdCategorys.cpdCategorys
});

export default compose(
  connect(mapStateToProps),
  branch(
    ({ allCpdCategories, industriesWithCpdCategorys }) =>
      !(
        allCpdCategories &&
        industriesWithCpdCategorys &&
        allCpdCategories.length > 0 &&
        industriesWithCpdCategorys.length > 0
      ),
    renderComponent(Loading)
  ),
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter:
        ({ showFilter }) =>
        () => ({
          showFilter: !showFilter
        })
    }
  ),
  withStateHandlers(
    ({ allCpdCategories }) => ({
      cpdCategorys: fp.flow(
        filterNonLegacy,
        fp.map((cpdCategory) => ({
          ...cpdCategory,
          selected: false
        }))
      )(allCpdCategories)
    }),
    {
      setCpdCategorys: () => (cpdCategorys) => ({
        cpdCategorys
      })
    }
  ),
  withHandlers({
    onCpdCategoryFilterChange:
      ({ onChange, cpdCategorys, setCpdCategorys }) =>
      (cpdCategoryId) => {
        const updatedCpdCategorys = getUpdatedCpdCategorys(
          cpdCategorys,
          cpdCategoryId
        );
        setCpdCategorys(updatedCpdCategorys);
        const selectedCpdCategoryIds = fp.flow(
          fp.filter('selected'),
          fp.map('id')
        )(updatedCpdCategorys);
        onChange({
          cpdCategoryIds: selectedCpdCategoryIds
        });
      }
  })
)(IndustryCpdCategoryFilter);



// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/industry-cpd-category-filter.js